import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const ModalConfirmacao = ({ show, onHide, onConfirm, dados, loading }) => {
  if (!dados) return null;
  const {
    quantidade,
    apelido_origem,
    apelido_destino,
    apelido_ge,
    codigo_origem,
    codigo_destino,
  } = dados;

  return (
    <Modal show={show} onHide={onHide} backdrop="static" centered>
      <Modal.Header closeButton>
        <Modal.Title>Confirmar transferência</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Você está prestes a transferir{' '}
          <strong>{quantidade}</strong> ocorrência(s) da conta{' '}
          <strong>
            [{codigo_origem}-{apelido_origem}]
          </strong>{' '}
          para a conta{' '}
          <strong>
            [{codigo_destino}-{apelido_destino}]
          </strong>{' '}
          no GE <strong>[{apelido_ge}]</strong>.
        </p>
        <p className="text-danger mb-0">
          <strong>Esta operação é irreversível.</strong>
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} disabled={loading}>
          Cancelar
        </Button>
        <Button variant="danger" onClick={onConfirm} disabled={loading}>
          {loading ? 'Transferindo...' : 'Confirmar'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalConfirmacao;
